import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    standalone: false,
    selector: '[appTrimOnBlur]',
})
export class TrimOnBlurDirective {
    private readonly ngControl = inject(NgControl);

    @HostListener('blur')
    onBlur(): void {
        const control = this.ngControl.control;
        if (typeof control?.value !== 'string') return;
        control.setValue(control.value.trim(), { emitEvent: false });
    }
}
